export default "/images/49be4111eef40b1afc6fb2e4b4262c0b.avif";